export function getUserRole() {
  const token = localStorage.getItem('accessToken') // Retrieve JWT
  if (!token) return null
  try {
    const payload = JSON.parse(atob(token.split('.')[1])) // Decode JWT
    return payload.role // Extract role
  } catch (e) {
    return null
  }
}
